
import Vue from 'vue'
import types from '../helpers/types'
import states from '../helpers/states'
import EntryState from '../components/EntryState.vue'
import EntryEditDialog from '../components/EntryEditDialog.vue'
import CallDialog from '../components/CallDialog.vue'
import DropDownPause from '../components/DropDownPause.vue'
import DropDownComment from '../components/DropDownComment.vue'
import gql from 'graphql-tag';
import addSeconds from 'date-fns/add_seconds';
import { Notify } from 'quasar'

export default Vue.extend({
  components: { EntryState, EntryEditDialog, CallDialog, DropDownPause, DropDownComment },
  props: {
    listId: {
      type: String,
      default: ''
    },
    entries: {
      type: Array,
      default: () => ([])
    },
    lists: {
      type: Array,
      default: () => ([])
    },
    users: {
      type: Array,
      default: () => ([])
    },
  },
  data() {
    return {
      editDialog: false,
      callDialog: false,
      mailDialog: false,
      isLoading: false
    }
  },
  computed: <any>{
    entry() {
      return this.entries.find((e: any) => e.id == this.$route.params.id)
    },
    type() {
      return types.find((t: any) => t.key == this.entry.type)
    },
    states() {
      return [].concat(this.entry.states).reverse()
    },
    stateOptions() {
      return states
    },
    emails() {
      return this.entry.mail.split(',').map((m: string) => m.trim())
    }
  },
  methods: <any>{
    async updateState(key: string, pauseDuration: number = 0, comment: string = '') {
      console.log({key,pauseDuration})
      if(this.isLoading) return
      this.$refs.mailsentmenu.hide()
      this.$refs.donemenu.hide()
      this.$refs.recievedmenu.hide()
      // return
      this.isLoading = true

      try {
        let pauseUntil: Date|null = null
        if(pauseDuration === Infinity) pauseUntil = new Date("2100-01-01")
        else if(pauseDuration) pauseUntil = addSeconds(new Date, pauseDuration)
        
        await this.$apollo.mutate({
          mutation: gql`
            mutation updateState ($id: String!, $key: String!, $listId: String!, $pauseUntil: DateTime, $comment: String) {
              updateState(key: $key, listId: $listId, id: $id, pauseUntil: $pauseUntil, comment: $comment) {
                id
              }
            }
          `,
          variables: {
            id: this.entry.id,
            key: key,
            listId: this.listId,
            pauseUntil: pauseUntil,
            comment: comment
          }
        })
      } catch(err) {
        Notify.create({
          message: err.message,
          color: 'red'
        })
      } finally {
        this.isLoading = false
      }
    },
    async acceptEntry() {
        const ownerListId = this.states[0].listId
        console.log(ownerListId)
        // return
        const res = await this.$apollo.mutate({
          mutation: gql`
            mutation share($ids: [String!]!, $listId: String!, $targetListId: String!) {
              shareEntries(targetListId: $targetListId, listId: $listId, ids: $ids)
            }
          `,
          variables: {
            ids: [this.entry.id],
            listId: ownerListId,
            targetListId: this.listId
          }
        })
    }
  }
})



